import { createContext, useContext, useEffect, useMemo, useState } from "react";
import ApiRequest from "./ApiRequest";
import { ApiEndpoints } from "./ApiEndpoints";

const endpoints = ApiEndpoints.rbac;

const PermissionContext = createContext({
  status: "loading",
  permissionSlugs: null,
  hasPermission: () => true,
});

export const usePermissions = () => useContext(PermissionContext);

export function PermissionProvider({ children }) {
  const [status, setStatus] = useState("loading");
  const [permissionSlugs, setPermissionSlugs] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let interval;

    const fetchPermissions = () => {
      ApiRequest("GET", endpoints.myPermissions)
        .then((response) => {
          if (cancelled) return;
          if (response?.is_super_admin) {
            setPermissionSlugs(null);
          } else {
            setPermissionSlugs(new Set((response?.permissions || []).map((permission) => permission.slug)));
          }
          setStatus("ready");
        })
        .catch(() => {
          if (cancelled) return;
          setPermissionSlugs(new Set());
          setStatus("ready");
        });
    };

    fetchPermissions();
    interval = setInterval(fetchPermissions, 600000);

    return () => {
      cancelled = true;
      if (interval) clearInterval(interval);
    };
  }, []);

  const value = useMemo(
    () => ({
      status,
      permissionSlugs,
      hasPermission: (slug) =>
        status !== "ready" ? true : permissionSlugs ? permissionSlugs.has(slug) : true,
    }),
    [status, permissionSlugs]
  );

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
